import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SYMPTOMS = [
  'Fatigue', 'Brain fog', 'Poor sleep', 'Low mood',
  'Anxiety', 'Weight gain', 'Low libido', 'Hot flushes',
  'Night sweats', 'Hair thinning', 'Joint aches', 'Irritability'
];

export default function SymptomChecker() {
  const [sex, setSex] = useState('');
  const [decade, setDecade] = useState('');
  const [symptoms, setSymptoms] = useState([]);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const toggleSymptom = (s) => {
    setSymptoms(prev =>
      prev.includes(s) ? prev.filter(x => x !== s) : [...prev, s]
    );
  };

  const handleSubmit = async () => {
    if (!sex || !decade || symptoms.length === 0) return;
    setLoading(true);
    setResult(null);

    try {
      const res = await fetch('/.netlify/functions/symptom-check', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sex, decade, symptoms }),
      });
      const parsed = await res.json();
      if (!res.ok || parsed.error) {
        setResult({ error: true });
      } else {
        setResult(parsed);
      }
    } catch {
      setResult({ error: true });
    }

    setLoading(false);
  };

  return (
    <div className="checker">
      <div className="checker__step">
        <div className="checker__label">I am a</div>
        <div className="checker__options">
          {['Woman', 'Man'].map(s => (
            <button
              key={s}
              className={`checker__opt ${sex === s ? 'checker__opt--selected' : ''}`}
              onClick={() => setSex(s)}
            >{s}</button>
          ))}
        </div>
      </div>

      <div className="checker__step">
        <div className="checker__label">I am in my</div>
        <div className="checker__options">
          {['30s', '40s', '50s', '60s+'].map(d => (
            <button
              key={d}
              className={`checker__opt ${decade === d ? 'checker__opt--selected' : ''}`}
              onClick={() => setDecade(d)}
            >{d}</button>
          ))}
        </div>
      </div>

      <div className="checker__step">
        <div className="checker__label">My main symptoms (select all that apply)</div>
        <div className="checker__options">
          {SYMPTOMS.map(s => (
            <button
              key={s}
              className={`checker__opt ${symptoms.includes(s) ? 'checker__opt--selected' : ''}`}
              onClick={() => toggleSymptom(s)}
            >{s}</button>
          ))}
        </div>
      </div>

      {!result && (
        <button
          className="checker__submit"
          onClick={handleSubmit}
          disabled={!sex || !decade || symptoms.length === 0 || loading}
        >
          {loading ? 'Finding your next step...' : 'Show my next step'}
        </button>
      )}

      {loading && <p className="checker__loading">Putting your questions together...</p>}

      {result && !result.error && (
        <div className="checker__result">
          {/* 9 Oct 2026: questions to take to a GP or pharmacist, and a guide.
              No product, stack or test is ever suggested here. */}
          <div className="checker__result-label">Before you see your GP or pharmacist</div>
          <p className="checker__result-text">{result.summary}</p>
          {result.prepare && <p className="checker__result-text">{result.prepare}</p>}
          {Array.isArray(result.questions) && result.questions.length > 0 && (
            <>
              <div className="checker__result-label" style={{ marginTop: '12px' }}>Questions you could ask</div>
              <ul style={{ margin: '0 0 14px', paddingLeft: '18px', fontSize: '14px', lineHeight: 1.6 }}>
                {result.questions.map((q, i) => <li key={i}>{q}</li>)}
              </ul>
            </>
          )}
          <p style={{ fontSize: '12px', color: 'var(--stone)', marginBottom: '14px' }}>
            This is information only, not medical advice or a diagnosis. Always speak to your GP.
          </p>
          <div className="checker__result-links">
            <Link
              to={`/${result.guide}`}
              className="btn-clay"
              style={{ fontSize: '13px', padding: '10px 16px' }}
            >
              Read the {result.guideLabel || 'guide'} guide
            </Link>
          </div>
          <button
            onClick={() => { setResult(null); setSex(''); setDecade(''); setSymptoms([]); }}
            style={{ fontSize: '12px', color: 'var(--stone)', background: 'none', border: 'none', marginTop: '14px', cursor: 'pointer' }}
          >
            Start again
          </button>
        </div>
      )}

      {result?.error && (
        <div className="checker__result">
          <p className="checker__result-text">Something went wrong. Please try again or explore the guides directly.</p>
        </div>
      )}
    </div>
  );
}
